
import styled from "styled-components";
import { BsSearch } from 'react-icons/bs'
export const Container = styled.div`
    display: flex;
    flex-shrink:1;
    font-family: Montserrat SemiBold, "Open Sans", Helvetica, Arial, sans-serif !important;
`

export const GContainer = styled.div`
    padding-top: 63px;
    padding-bottom:63px;
    display: grid;
    grid-template-columns: 100%;
     font-family: Montserrat SemiBold, "Open Sans", Helvetica, Arial, sans-serif !important;
`
export const Container1 = styled.div`
    display: flex;
    flex-shrink:1;
    font-family: Montserrat SemiBold, "Open Sans", Helvetica, Arial, sans-serif !important;
`

export const Heading = styled.div`
font-size: 30px;
font-weight: 600;
color: #58595B;
cursor:pointer;
margin:4px 0px 0px 0px;
font-family: Montserrat SemiBold, "Open Sans", Helvetica, Arial, sans-serif !important;
@media (max-width: 1145px) {
    font-size: 24px !important;
    margin:10px 0px 10px 0px;
  } 
@media (max-width: 794px) {
    font-size: 21px !important;

  } 
`
export const Seachbar = styled.div`
position: relative;
flex-shrink: 1;
flex-grow: 1;
background-color: white;
cursor:pointer;
border: 1px solid #c5c5c5;
border-radius: 10px;
width:100%;
padding: 13px 30px;
font-family: Montserrat SemiBold, "Open Sans", Helvetica, Arial, sans-serif !important;
&:focus{
    border-color: black;
}

`

export const Input = styled.input`
width: 100%;
border: none !important;
padding: 5px 0px 0 40px;
font-size: 16px;
outline: none !important;
}
`
export const CustomBsSearch = styled(BsSearch)`
position: absolute;
top: 16px;
left: 22px;
font-size: 24px;
@media (max-width: 1145px) {
    width: 20px !important;
  } 
`

export const MobileNav = styled.div`
  display:none;
  opacity:0;
  visibility; hidden;
  @media(max-width:990px){
    display:block;
    opacity:1;
    visibility; visible;
    position : fixed;
    top:0;
    width:100%;
    left:0;
    padding:20px 20px 20px 0;
    mix-blend-mode:normal;
    background:#fff;
    z-index:9999;
    img {
      position:relative;
      width: 77px;
      top: 0;
      left: 30px;

    }
  }
`
export const ToggleMenu = styled.div`
    display: inline-block;
    text-align:right;
    span{
    display: block;
    height: 5px;
    width: 44px;
    background: #2196f3;
    margin-bottom: 7px;
    border-radius: 49px;
    transition: all 0.3s ease 0s;
  }
    &.activeToggle{
      span:nth-child(1){
        transform: rotateZ(45deg);
        right: 0px;
        position: relative;
        top: 12px;
      }
      span:nth-child(2){
        display:none;
      }
      span:nth-child(3){
        transform: rotateZ(-45deg);
        position: relative;
        top: 1px;
        right: 1px;
      }
    }
`